<template>
    <div :class="itemClass">
        <router-link :to="route.route">
            {{ route.label }}
        </router-link>
    </div>
</template>

<script>
    import { isRouteNameEqual, matchFullRoute } from '~/helpers'

    export default {
        props: {
            route: { type: Object, default: undefined },
        },

        data() {
            return {}
        },

        computed: {
            itemClass() {
                return {
                    'subdomain-main-menu__item': true,
                    'subdomain-main-menu__item--is-current': this.route.route
                        ? this.route.route.matchFullRoute
                            ? matchFullRoute(this.route.route, this.$route, 2)
                            : isRouteNameEqual(this.route.route.name, this.$route.name, 2)
                        : false,
                }
            },
        },
    }
</script>
